export default "__VITE_ASSET__BjMaVgm7__"